import { render } from "./productoCard.vue?vue&type=template&id=42cde30e&scoped=true"
import script from "./productoCard.vue?vue&type=script&lang=js"
export * from "./productoCard.vue?vue&type=script&lang=js"

import "./productoCard.vue?vue&type=style&index=0&id=42cde30e&scoped=true&lang=css"
import "./productoCard.vue?vue&type=style&index=1&id=42cde30e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cde30e"]])

export default __exports__